export const baseServerUrl = process.env.REACT_APP_BACKEND_SERVER_URL;
export const baseNextAppUrl = process.env.REACT_APP_NEXT_APP_URL;

export const baseUrl = baseServerUrl + '/api';

export const dotNetDashBoardUrl = process.env.REACT_APP_NET_BACKEND_SERVER_URL;
